"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = (0, tslib_1.__importStar)(require("react"));
var prop_types_1 = (0, tslib_1.__importDefault)(require("prop-types"));
var react_idle_timer_1 = (0, tslib_1.__importDefault)(require("react-idle-timer"));
var launchdarkly_react_client_sdk_1 = require("launchdarkly-react-client-sdk");
var withNTLDProvider_1 = require("../../withNTLDProvider");
var SessionTimeoutModal_1 = (0, tslib_1.__importDefault)(require("./SessionTimeoutModal"));
var routes_1 = require("../../auth/routes");
var DEFAULT_AUTH_MS_TIMEOUT = 1800000;
var DEFAULT_LOGOUT_MODAL_MS_TIMEOUT = 1500000;
var SessionTimeoutComponent = function (props) {
    var history = props.history;
    // TODO: define ntConfig with hook or window.ntConfig
    var authTimeout = ntConfig.AuthTimeout || DEFAULT_AUTH_MS_TIMEOUT;
    var logoutModalTimeout = ntConfig.LogoutModalTimeout || DEFAULT_LOGOUT_MODAL_MS_TIMEOUT;
    var _a = (0, react_1.useState)(false), isLogoutModalActive = _a[0], setIsLogoutModalActive = _a[1];
    var _b = (0, react_1.useState)(authTimeout - logoutModalTimeout), timeRemainingUntilLogout = _b[0], setTimeRemainingUntilLogout = _b[1];
    var authTimeoutTimerRef = (0, react_1.useRef)(null);
    var tick = (0, react_1.useCallback)(function (authTimeoutTimerCurrentRef) {
        setTimeRemainingUntilLogout(authTimeoutTimerCurrentRef.getRemainingTime());
    }, []);
    (0, react_1.useEffect)(function () {
        if (isLogoutModalActive && authTimeoutTimerRef.current) {
            setTimeRemainingUntilLogout(authTimeoutTimerRef.current.getRemainingTime());
            var interval_1 = setInterval(tick, 1000, authTimeoutTimerRef.current);
            return function () {
                clearInterval(interval_1);
            };
        }
        return function () { };
    }, [isLogoutModalActive, tick]);
    var _c = (0, launchdarkly_react_client_sdk_1.useFlags)().enableSessionTimeoutModal, enableSessionTimeoutModal = _c === void 0 ? false : _c;
    if (!enableSessionTimeoutModal) {
        return null;
    }
    var openLogoutModal = function () {
        setIsLogoutModalActive(true);
    };
    var closeLogoutModal = function () {
        setIsLogoutModalActive(false);
    };
    var logout = function () {
        history.push(routes_1.routes.logout);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_idle_timer_1.default, { ref: authTimeoutTimerRef, onIdle: logout, timeout: authTimeout }),
        react_1.default.createElement(react_idle_timer_1.default, { onIdle: openLogoutModal, timeout: logoutModalTimeout }),
        react_1.default.createElement(SessionTimeoutModal_1.default, { open: isLogoutModalActive, onClose: closeLogoutModal, onConfirm: closeLogoutModal, onSecondary: logout, timeRemainingInMilliseconds: timeRemainingUntilLogout })));
};
SessionTimeoutComponent.propTypes = {
    history: prop_types_1.default.shape().isRequired,
};
exports.default = (0, withNTLDProvider_1.withNTLDProvider)(SessionTimeoutComponent);
